module.exports = __webpack_public_path__ + "static/Essential Addons for Elementor-424621f0739ef5d5ae1c07dc43ee827d.svg";